import {Component, Input, OnInit} from '@angular/core';
import {AlertController, LoadingController, ToastController} from '@ionic/angular';
import {UserOptions} from '../../../interfaces/userOptions';
import {User} from '../../../providers/user/user';
import {PatientDataProvider} from '../../../providers/patient-data/patient-data';
import {PatientData} from '../../../interfaces/patient-data';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {Role} from '../../../interfaces/userProfile';
import {ViewController} from '../../../providers/view-controller.service';
import {PageController} from '../../../page-controller/page.controller';
import {Page} from '../../../page-controller/page.type';

@Component({
  selector: 'page-account-add',
  templateUrl: 'account-add.html',
  styleUrls: ['./account-add.scss']
})
export class AccountAddPage implements OnInit {
  @Input() relationOnly;
  @Input() id;

  user: UserOptions = new UserOptions();
  showClose = false;
  isFromPatient = false;
  hasAppId = false;
  transmitterId: string;
  relationAppId: string;
  relationalUser: any;
  error = '';
  rolesArray = [];
  roles = Role;

  formBuilder: UntypedFormBuilder = new UntypedFormBuilder();

  register: UntypedFormGroup = this.formBuilder.group({
    lastname: new UntypedFormControl('', Validators.compose([
        Validators.minLength(3),
        Validators.required
      ])
    ),
    firstname: new UntypedFormControl('', Validators.compose([
        Validators.minLength(3),
        Validators.required
      ])
    ),
    username: new UntypedFormControl('', Validators.compose([
        Validators.minLength(3),
        Validators.required
      ])
    ),
    callNumber: new UntypedFormControl('', Validators.compose([
        Validators.minLength(6)
      ])
    ),
    email: new UntypedFormControl('', Validators.compose([
      Validators.required,
      Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
    ])),
    role: new UntypedFormControl('', Validators.compose([])),
    alertGroups: new UntypedFormControl([], Validators.compose([]))
  });

  constructor(private viewCtrl: ViewController,
              private pageController: PageController,
              private patientProvider: PatientDataProvider,
              private alertCtrl: AlertController,
              private loadingController: LoadingController,
              private toastController: ToastController,
              private userProvider: User,
              public translate: TranslateService) {
    console.log(this.user);
  }

  ngOnInit() {
    this.rolesArray = Object.keys(this.roles).filter(e => e !== 'empty');

    if (this.relationOnly) {
      // wenn man von PatienPage einen Angehoerigen registriert
      this.relationalUser = this.relationOnly;

      this.showClose = true;
      this.isFromPatient = true;
      this.transmitterId = this.id;
      this.relationAppId = this.guid();

      this.register.controls.lastname.setValue(this.relationalUser.lastname);
      this.register.controls.firstname.setValue(this.relationalUser.firstname);
      this.register.controls.username.setValue((this.relationalUser.firstname + this.relationalUser.lastname).toLocaleLowerCase());
      this.register.controls.email.setValue(this.relationalUser.email);
    }
  }

  save() {
    // prüfen ob alle Felder befüllt und korrekt in VIEW sind
    if (this.register.status === 'INVALID') {
      this.messageToast(this.translate.instant('Message.DataError'));
      return;
    }

    let alertGroups = this.transmitterId ? [this.transmitterId] : this.register.controls.alertGroups.value;

    alertGroups = alertGroups.map(data => {
      if(typeof data === "object") {
        return data = data.value.toLowerCase();
      } else {
        return data.toLowerCase();
      }
    });

    // user-Objekt vorbereiten
    const pass = this.guid();
    const user = {
      profile: {
        firstname: this.register.controls.firstname.value,
        lastname: this.register.controls.lastname.value,
        role: this.isFromPatient ? 'relationOnly' : this.register.controls.role.value,
        alertGroups: alertGroups,
        callNumber: this.register.controls.callNumber.value
      },
      username: this.register.controls.username.value.toLocaleLowerCase(),
      email: this.register.controls.email.value,
      password: pass,
      confirmPassword: pass
    };

    // when is modal, d.h. kommt von PatientenPage
    // prüfen, ob der Angehörige mit diesen Daten schon angelegt wurde
    if (this.isFromPatient) {
      // Patienten holen, in deren Kontakten es Angehörigen mit **email** gibt
      this.patientProvider.getRelationByEmail({email: user.email}).subscribe((data: any) => {
        // wenn es jemand mit der email gibt
        if (data.data.data.data.docs.length > 0) {
          // fragen ob es mit ihm verknüpft werden soll
          this.alert().then(async shouldConnect => {
            if (shouldConnect) {
              const load = await this.loadingController.create({message: this.translate.instant('Loading.UserAdd')});
              await load.present();
              // Benutzer mit der oberen **email** suchen
              this.userProvider.getByEmail(user.email).then((doc: any) => {
                const _user: UserOptions = doc.data.data.data.docs[0];
                // und wenn es benutzer gibt und solche AlarmGruppe noch nicht hinzugefügt war
                if (_user && this.transmitterId && _user.profile.alertGroups.indexOf(this.transmitterId) === -1) {
                  // dann die AlarmGruppe hinzufügen
                  _user.profile.alertGroups.push(this.transmitterId.toString());
                  // und dies speichern
                  this.userProvider.update(_user);
                  // schliesslich user._id als appId in Patient.contacts hinzufügen
                  this.saveContactData(_user._id);
                }
              }).catch(error => {
                console.log(error);
              });
              load.dismiss();
              this.dismiss();
            } else {
              // hier möchte man den Angehörigen NICHT verknüpfen
              // und Benutzer mit der **email** war schon angelegt
              this.messageToast(this.translate.instant('Message.EMailError'));
              // this.saveUserData(user);
            }
          });
        } else {
          // wenn es keine Benutzer mit dieser **email** gibt, einfach speichern
          this.saveUserData(user);
        }
      });
    } else {
      // wenn nicht vom PatientPage geöffnet, einfach speichern
      this.saveUserData(user);
    }
  }

  dismiss(data = null) {
    if (data) {
      this.viewCtrl.dismiss(data);
    } else {
      this.viewCtrl.dismiss();
    }

  }

  private guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }

  private async alert(): Promise<boolean> {
    let connectUser;
    const connect = new Promise<boolean>(resolve => connectUser = resolve);

    const confirm = await this.alertCtrl.create(
      {
        header: this.translate.instant('UserExist'),
        message: this.translate.instant('Message.UserExist'),
        buttons:
          [
            {
              text: this.translate.instant('NO'),
              role: 'cancel',
              cssClass: 'secondary',
              handler: _ => connectUser(false)
            }, {
            text: this.translate.instant('Link'),
            cssClass: 'alert-success-button',
            handler: _ => connectUser(true)
          }
          ]
      }
    );
    await confirm.present();
    return connect;
  }

  private async messageToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  private async saveUserData(user: any) {
    this.error = '';
    const load = await this.loadingController.create({message: this.translate.instant('Loading.UserAdd')});
    await load.present();

    if (this.isFromPatient) {
      user.alertGroups = [this.transmitterId.toString()];
    }

    // user data speichern
    this.userProvider.add(user).then((updateRes: any) => {
      // und wenn Angehöriger-Profile
      // die appId in Patient.Contacts speichern
      if (this.isFromPatient) {
        this.saveContactData(user.username).then(() => {
          load.dismiss();
          this.dismiss(user.username);
          this.messageToast(this.translate.instant('Message.MemberAdd'));
        });
      } else {
        load.dismiss();
        this.messageToast(this.translate.instant('Message.UserDataSave'));
        this.pageController.navigateRoot(Page.Accounts);
      }
    }).catch((err) => {
      console.log(err);
      load.dismiss();
      if (err.error.error === 'Validation failed') {
        Object.keys(err.error.validationErrors).forEach((key) => {
          err.error.validationErrors[key].forEach((text) => {
            this.translate.get(text.replace(/ /g, '_')).subscribe((res) => {
              this.error += res + '<br />';
            });
          });
        });
      }

      this.messageToast(this.translate.instant('Message.Error'));
    });
  }

  private saveContactData(appId: string) {
    return new Promise((resolve) => {
      this.patientProvider.query({transmitterId: this.transmitterId}).subscribe((val: any) => {
        const patient: PatientData = val.data.data.data.docs[0];
        // Contant-Objekt zum JSON parsen,
        const json_contact = JSON.stringify(this.relationalUser);
        patient.contacts.forEach((e) => {
          // um hier mit dem anderen Objekt vergleichen zu können
          if (JSON.stringify(e) === json_contact) {
            // und dem richtigen Kontakt die appId hinzufügen
            e.appId = appId;
          }
        });

        this.patientProvider.update(patient).subscribe((updateRes: any) => {
          patient._rev = updateRes.data.data.data.rev;
          this.patientProvider.activePatientData = patient;
          resolve(null);
        });
      });
    });
  }

}
